export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.auth_token) {
    return "Bearer " + user.auth_token ;
  } else {
    return {};
  }
}